<template>
  <el-form ref="awemeVideoRef" :model="form" :rules="rules" label-width="0">
    <el-form-item>
      <el-input v-model="creativeForm.creative_name" placeholder="请输入创意组名称" style="width: 320px"></el-input>
      <span>&emsp;</span>
      <slot> </slot>
    </el-form-item>

    <el-form-item prop="selectedMaterials.video">
      <AwemeVideoBox
        :value="creativeForm.selectedMaterials.video"
        :selectable="false"
        :data="creativeForm.selectedMaterials.video"
        @remove="onAwemeVideoItemRemove"
      ></AwemeVideoBox>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref } from 'vue'
import AwemeVideoBox from './components/aweme-video-selector/aweme-video-box.vue'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})
// eslint-disable-next-line
const emit = defineEmits(['update:form', 'change', 'get-aweme-video'])
const creativeForm = ref({ ...props.form })

const awemeVideoRef = ref(null)

const rules = {
  'selectedMaterials.video': [
    { required: true, message: '请选择达人视频', trigger: 'change' },
    { type: 'array', min: 1, message: '至少选择一个视频素材' }
  ]
}

function onAwemeVideoItemRemove(item) {
  const videos = creativeForm.value.selectedMaterials.video
  const newList = videos.filter((i) => i.video_info.item_id !== item.video_info.item_id)
  creativeForm.value.selectedMaterials.video = newList
  const newForm = creativeForm.value
  emit('update:form', { ...newForm })
}

function validate() {
  return awemeVideoRef.value.validate()
}

// eslint-disable-next-line
defineExpose({
  validate
})
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  &-between {
    justify-content: space-between;
  }
}
.selected-materials {
  .selected-videos {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }
  .image-box {
    cursor: pointer;
    position: relative;
    width: 165px;
    img {
      width: 100%;
    }
  }
  .tools-group {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 10px;
    .el-icon-circle-check {
      cursor: pointer;
      color: #1974ff;
      font-size: 18px;
    }
  }
}
</style>
